<div class="toast-container" data-testid="toast-container">
  @for (toast of toastService.activeToasts(); track toast.id) {
    <div 
      class="toast-item"
      [class.toast-item--success]="toast.type === 'success'"
      [class.toast-item--error]="toast.type === 'error'"
      [class.toast-item--warning]="toast.type === 'warning'"
      [class.toast-item--info]="toast.type === 'info'"
      [attr.data-testid]="'toast-' + toast.id"
    >
      <div class="toast-item__icon">
        @switch (toast.type) {
          @case ('success') {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/>
              <polyline points="22,4 12,14.01 9,11.01"/>
            </svg>
          }
          @case ('error') {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M15 9l-6 6M9 9l6 6"/>
            </svg>
          }
          @case ('warning') {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 9v4M12 17h.01"/>
              <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
            </svg>
          }
          @default {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 16v-4M12 8h.01"/>
            </svg>
          }
        }
      </div>
      <span class="toast-item__message">{{ toast.message }}</span>
      <button 
        class="toast-item__close"
        (click)="toastService.remove(toast.id)"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M18 6 6 18M6 6l12 12"/>
        </svg>
      </button>
    </div>
  }
</div>
